<template>
    <div id="particles-js" class="particles-container"></div>
  </template>

  <script>
  export default {
    name: "ParticlesBackground",
    mounted() {
      // 直接加载CDN版本的particles.js
      this.loadParticlesJS().then(() => {
        window.particlesJS('particles-js', this.getConfig());
      });
    },
    methods: {
      loadParticlesJS() {
        return new Promise((resolve) => {
          if (window.particlesJS) return resolve();

          const script = document.createElement('script');
          script.src = 'https://cdn.jsdelivr.net/particles.js/2.0.0/particles.min.js';
          script.onload = resolve;
          document.head.appendChild(script);
        });
      },
      getConfig() {
        return {
          particles: {
            number: { value: 60, density: { enable: true, value_area: 800 } },
            color: { value: "#00B4FF" },
            shape: { type: "circle" },
            opacity: { value: 0.7, random: true, anim: { enable: false } },
            size: { value: 3, random: true, anim: { enable: true, speed: 2, size_min: 0.3 } },
            line_linked: { enable: true, distance: 150, color: "#1A4B8C", opacity: 0.3, width: 1 },
            move: { enable: true, speed: 1.2, direction: "none", random: true, out_mode: "bounce" }
          },
          interactivity: {
            detect_on: "window",
            events: {
              onhover: { enable: true, mode: "bubble" },
              onclick: { enable: true, mode: "push" },
              resize: true
            },
            modes: {
              bubble: { distance: 100, size: 6, duration: 0.3 },
              push: { particles_nb: 4 }
            }
          },
          retina_detect: true
        };
      }
    }
  }
  </script>

  <style scoped>
  .particles-container {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 0;
  }
  </style>